import { Reveal } from "../motion";

export const Logo = ({ dark = false, className = "" }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <img src="/images/bsm-logo.png" alt="Blank Space Media logo" className="w-14 h-14 rounded-xl shrink-0" />
    <span className={`text-[11px] font-semibold uppercase tracking-[0.28em] leading-none ${dark ? "text-[#F5F3EE]" : "text-[#242424]"}`}>
      Blank Space
      <span className={`block text-[8px] tracking-[0.42em] mt-1 ${dark ? "text-[#F5F3EE]/60" : "text-[#242424]/55"}`}>Media</span>
    </span>
  </span>
);

export const Eyebrow = ({ children, light = false, className = "" }) => (
  <p className={`text-xs font-semibold uppercase tracking-[0.24em] ${light ? "text-[#FFD400]" : "text-[#B66E50]"} ${className}`}>
    {children}
  </p>
);

export const Section = ({ id, theme = "cream", children, className = "" }) => {
  const themes = {
    cream: "bg-[#F6F0E6] text-[#242424]",
    sage: "bg-[#E6E8DE] text-[#26342E]",
    forest: "bg-[#26342E] text-[#F6F0E6]",
    neutral: "bg-[#F5F3EE] text-[#242424]",
    charcoal: "bg-[#242424] text-[#F5F3EE]",
    ink: "bg-[#0F0F0F] text-[#F5F3EE]",
  };
  return (
    <section id={id} data-testid={`section-${id}`} className={`relative scroll-mt-20 ${themes[theme]} ${className}`}>
      {children}
    </section>
  );
};

export const SectionHead = ({ eyebrow, title, intro, light = false, className = "" }) => (
  <div className={`max-w-3xl ${className}`}>
    <Reveal>
      <Eyebrow light={light}>{eyebrow}</Eyebrow>
    </Reveal>
    <Reveal delay={1}>
      <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light leading-[1.12] tracking-tight mt-5">{title}</h2>
    </Reveal>
    {intro && (
      <Reveal delay={2}>
        <p className={`text-base sm:text-lg leading-relaxed mt-6 ${light ? "text-[#F5F3EE]/70" : "text-[#242424]/70"}`}>{intro}</p>
      </Reveal>
    )}
  </div>
);

export const Wrap = ({ children, className = "" }) => (
  <div className={`max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 ${className}`}>{children}</div>
);
